<template>
  <Progressbar v-if="loading" />
  <NetworkError v-else-if="errors" @tryAgain="Auth.getUser()" />
  <div class="w-11/12 md:w-6/12 xl:w-4/12 2xl:w-3/12 h-full flex" v-else>
    <Form @submit="onSubmit" v-slot="{ errors }" class="w-full my-auto">
      <div class="alert text-white mb-7"
        :class="[user.status === 'active' ? 'alert-success' : (user.status === 'pending' ? 'alert-warning' : 'alert-error')]">
        <span class="mx-auto" v-if="['active', 'pending'].includes(user.status)">
          {{ __(user.status === 'active' ? 'Your account has been verified' :
            'Your account is pending review and after confirmation, you will be able to place an order') }}</span>
        <span class="mx-auto block" v-else>
          {{ __(user.status === 'rejected' ? 'Your account was not approved for the following reasons!'
            : 'Your account is limited') }}
          <span class="text-sm block" v-if="user.message">{{ user.message }}</span>
        </span>
      </div>
      <div>
        <input type="file" accept=".png,.jpeg,.webp" name="image" class="hidden" id="choose-image" @change="upload">
        <label className="avatar mx-auto flex justify-center items-center cursor-pointer" for="choose-image">
          <div className="w-28 h-28 rounded-full relative">
            <img :src="user.image || imgProfile" alt="profile">
            <div class=" absolute bg-black/30 hover:bg-black/40 w-full h-full flex top-0 justify-center items-center">
              <ArrowUpTrayIcon class="w-7 h-7 text-primary" />
            </div>
          </div>
        </label>
        <div class="form-control my-3">
          <div class="card bg-base-100" v-if="user.expert?.name">
            <div class="card-body text-center p-5">
              <h6 class="card-title text-sm text-red-custom-2">{{ __('Sales Expert') }}</h6>
              <div class="divider my-0 h-auto bg-red-custom-2"></div>
              <div class="flex justify-between mt-4">
                <span class="text-sm font-medium">{{ __('Full Name') }}</span>
                <div>
                  <span class="font-medium">{{ user.expert.name }}</span>
                </div>
              </div>
              <div class="divider my-0 h-auto"></div>
              <div class="flex justify-between">
                <span class=" text-sm font-medium">{{ __('Phone number') }}</span>
                <div>
                  <span class="text-sm font-medium">{{ user.expert.phone }}</span>
                </div>
              </div>
            </div>
          </div>
          <Field type="number" :placeholder="__('phone number')" name="phone" v-model="user.phone" disabled
            rules="required|digits:11" :class="{ 'input-error': errors.phone }"
            class="input mt-4 text-center bg-blue-custom-1 text-blue-custom-2 placeholder-blue-custom-2" />
          <Field type="text" :placeholder="__('Full Name')" name="name" v-model="user.name" rules="required" disabled
            :class="{ 'input-error': errors.name }"
            class="input mt-4 text-center bg-blue-custom-1 text-blue-custom-2 placeholder-blue-custom-2" />
          <Field type="text" :placeholder="__('store\'s name')" name="shop_name" v-model="user.shop_name"
            rules="required" :class="{ 'input-error': errors.shop_name }"
            class="input mt-4 text-center bg-blue-custom-1 text-blue-custom-2 placeholder-blue-custom-2" />
          <Field name="city" v-model="user.city" rules="required">
            <v-select :options="cities" label="name" :reduce="city => city.name" dir="rtl" v-model="user.city"
              :placeholder="__('Select the city')"
              class="input mt-4 text-center text-blue-custom-2 bg-blue-custom-1 placeholder-blue-custom-2"
              :selectable="(option) => option.province_id > 0" :clearable="false"
              :class="{ 'input-error': errors.city }"></v-select>
          </Field>

          <Field type="text" :placeholder="__('Store Address')" name="shop_address" v-model="user.shop_address"
            rules="required" :class="{ 'input-error': errors.shop_address }"
            class="input mt-4 text-center bg-blue-custom-1 text-blue-custom-2 placeholder-blue-custom-2" />
        </div>
        <div class="form-control mt-3">
          <label class="label cursor-pointer justify-start">
            <input type="checkbox" v-model="user.notification" class="checkbox" />
            <span class="label-text text-error font-bold mr-3">{{ __('Show message notification window') }}</span>
          </label>
        </div>
      </div>
      <div class="form-control pb-6">
        <button type="submit" class="btn btn-primary mt-4" :class="{ 'loading': submit }">
          {{ __('Save changes and reauthenticate') }}
        </button>
                <span class="text-sm mt-3 text-center" v-if="privacy && user.privacy_confirm">
          <span>{{ __('You') }}</span> <label class="btn-link inline-block cursor-pointer" for="modal-privacy">{{
            __('Terms and Conditions') }}</label> <span>{{ __('You have read and accepted') }}</span>
        </span>
      </div>
    </Form>
  </div>
    <Teleport to="#app" v-if="privacy">
  <input type="checkbox" id="modal-privacy" class="modal-toggle" :checked="!loading && !user.privacy_confirm" />
  <div class="modal">
    <Form @submit="updatePrivacy" class="modal-box overflow-y-hidden" v-slot="{ errors }">
      <label for="modal-privacy" class="btn btn-sm btn-circle absolute left-2 top-2" v-if="user.privacy_confirm">✕</label>
      <h3 class="font-bold text-lg">{{ __('Terms and Conditions') }}</h3>
       <div class="modal-content h-[640px]">
      <div v-html="privacy" class="mt-3"></div>
      </div>
      <div class="modal-action justify-between" v-if="!user.privacy_confirm">
        <label class="label justify-center">
          <Field type="checkbox" v-model="privacyConfirm" name="privacy_confirm" rules="required" value="1"
            :class="['checkbox checkbox-primary checkbox-sm', { 'checkbox-error': errors.privacy_confirm }]" />
          <span class="label-text font-bold mr-3 text-xs md:text-sm">
            {{ __('Terms and Conditions') }} {{ __('I accept and agree with that.') }}
          </span>
        </label>
        <button class="btn btn-error btn-sm" :class="{ 'loading': submit }">{{ __('Confirm') }}</button>
      </div>
    </Form>
  </div>
  </Teleport>
</template>
<script setup>
import Auth from "../../../composables/shop/auth";
import { Field, Form } from "vee-validate";
import { ArrowUpTrayIcon } from '@heroicons/vue/24/outline'
import { computed, onMounted, reactive, ref } from "vue";

const loading = Auth.loading;
const user = Auth.user;
const privacyConfirm = ref(false);
const privacy = Auth.privacy;
const cities = Auth.cities;
const errors = Auth.errors;
const submit = Auth.submit;
const imgProfile = computed(() => window.APP_URL + '/assets/uploads/profile.png');
const onSubmit = () => Auth.updateUser(user);
const updatePrivacy = () => Auth.updateUser({privacy_confirm: true});
const upload = (e) => Auth.uploadImage(e.target.files[0])
onMounted(() => Auth.editUser())
</script>